import { useIntl } from '@capsicum/common';

export const useNCRegistrationRecoveryKit = () => {
	const { $t } = useIntl();

	const texts = {
		buttonContinue: $t('global.button.continue'),
		buttonCopySnack: $t('ncOnboarding.recoveryKit.buttonCopySnack'),
		buttonDownload: $t('ncOnboarding.recoveryKit.buttonDownload'),
		inputRecoveryCode: $t('ncOnboarding.recoveryKit.form.inputRecoveryCode'),
		inputRecoveryKeyId: $t('ncOnboarding.recoveryKit.form.inputRecoveryKeyId'),
		subtitle: $t('ncOnboarding.recoveryKit.subtitle'),
		title: $t('ncOnboarding.recoveryKit.title')
	};

	return texts;
};
